import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MyContext } from "../hooks/MyContextProvider";
import { toast } from "react-toastify";
import { AddToCart } from "../Libs/api";
import nodata from "../assets/img/nodata.gif";

function ShoppingCart({ isOpen, onClose }) {
  const { allCart, callCartAPI, totalSalePrice, totalOriginalPrice } =
    useContext(MyContext);
  const [loading, setLoading] = useState(false);
  console.log(allCart, "allCart");

  useEffect(() => {
    const handleClickOutside = (event) => {
      const mobileMenu = document.getElementById("cart-offCanvas");
      if (mobileMenu && !mobileMenu.contains(event.target)) {
        onClose(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleUpdateCart = async (id, qty) => {
    try {
      setLoading(true);
      let formData = new FormData();
      formData.append("Token", localStorage.getItem("token"));
      formData.append("ProductId", id);
      formData.append("Quantity", qty);

      const apiCall = await AddToCart(formData);
      if (apiCall.status === "1") {
        setLoading(false);
        callCartAPI();
      } else {
        setLoading(false);
        toast.error(apiCall?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error);
    }
  };
  // if (!isOpen) return null;

  return (
    <div
      id="cart-offCanvas"
      className={`offCanvas__minicart ${isOpen ? "active" : ""}`}
      onClick={() => onClose(false)}
    >
      <div className="minicart__header" onClick={(e) => e.stopPropagation()}>
        <div className="minicart__header--top d-flex justify-content-between align-items-center">
          <h3 className="minicart__title">Shopping Cart</h3>
          <button
            className="minicart__close--btn"
            onClick={() => onClose(false)}
            aria-label="minicart close btn"
          >
            <svg
              className="minicart__close--icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="32"
                d="M368 368L144 144M368 144L144 368"
              ></path>
            </svg>
          </button>
        </div>
      </div>
      <div
        className="minicart__product"
        style={{ position: "relative", height: "calc( 100vh - 138px)" }}
        onClick={(e) => e.stopPropagation()}
      >
        {allCart && allCart.length > 0 ? (
          <>
            <div style={{ height: "calc( 100vh - 243px)", overflowY: "auto" }}>
              {allCart?.map((item, i) => (
                <div key={i} className="minicart__product--items d-flex">
                  <div className="minicart__thumb">
                    <Link
                      to={`/product-details/${item?.ProductId}`}
                      onClick={() => onClose(false)}
                    >
                      <img src={item?.ProductImg} alt="product" />
                    </Link>
                  </div>
                  <div className="minicart__text">
                    <h4 className="minicart__subtitle">
                      <Link
                        to={`/product-details/${item?.ProductId}`}
                        onClick={() => onClose(false)}
                      >
                        {item?.ProductName}
                      </Link>
                    </h4>
                    <span className="color__variant">
                      {item?.QuantityBundle} -{" "}
                      {item.IsOffer ? item.SalePrice : item.BuyPrice}
                    </span>
                    <div className="minicart__price">
                      <span className="minicart__current--price">
                        ₹{item.IsOffer ? item.SalePrice : item.BuyPrice}
                      </span>
                      <span className="minicart__old--price">
                        {" "}
                        ₹{item?.BuyPrice}
                      </span>
                    </div>
                    <div className="minicart__text--footer d-flex align-items-center">
                      <div className="quantity__box minicart__quantity">
                        <button
                          type="button"
                          className="quantity__value decrease"
                          aria-label="quantity value"
                          style={{
                            height: "30px",
                            width: "33px",
                            fontSize: 18,
                          }}
                          onClick={() => {
                            handleUpdateCart(
                              item?.ProductId,
                              +item?.Quantity - 1
                            );
                          }}
                        >
                          -
                        </button>
                        <label>
                          <input
                            type="number"
                            className="quantity__number"
                            value={item?.Quantity}
                            style={{
                              height: "30px",
                              width: "33px",
                              fontSize: 18,
                            }}
                            data-counter=""
                            disabled
                          />
                        </label>
                        <button
                          type="button"
                          className="quantity__value increase"
                          aria-label="quantity value"
                          value="Increase Value"
                          style={{
                            height: "30px",
                            width: "33px",
                            fontSize: 18,
                          }}
                          onClick={() => {
                            handleUpdateCart(
                              item?.ProductId,
                              +item?.Quantity + 1
                            );
                          }}
                        >
                          +
                        </button>
                      </div>
                      <button
                        onClick={() => {
                          handleUpdateCart(item?.ProductId, 0);
                        }}
                        className="minicart__product--remove"
                        type="button"
                        style={{ fontSize: 12 }}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div>
              <div
                className="minicart__amount"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="minicart__amount_list d-flex justify-content-between">
                  <span style={{ fontSize: 18 }}>Total:</span>
                  <span style={{ fontSize: 18 }}>
                    <b>
                      ₹ {totalSalePrice ? totalSalePrice : totalOriginalPrice}
                    </b>
                  </span>
                </div>
              </div>

              <div
                className="mt-4 minicart__button gap-2 d-flex justify-content-center"
                onClick={(e) => e.stopPropagation()}
              >
                <Link
                  onClick={() => {
                    onClose(false);
                  }}
                  className="filter-btn active text-white w-100"
                  style={{ maxWidth: "50%", textAlign: "center" }}
                  to="/cart"
                >
                  View cart
                </Link>
                <Link
                  onClick={() => {
                    onClose(false);
                  }}
                  className="filter-btn active text-white w-100"
                  style={{ maxWidth: "50%", textAlign: "center" }}
                  to="/checkout"
                >
                  Checkout
                </Link>
              </div>
            </div>
          </>
        ) : (
          <div className="text-center py-4">
            <img
              src={nodata}
              alt="No items in cart"
              className="mb-4"
              style={{
                maxWidth: "250px",
                marginRight: "auto",
                marginLeft: "auto",
              }}
            />
            <h4>Your Cart is Empty!</h4>
            <p className="mb-3">
              Looks like you haven't added any items to your cart yet.
            </p>
            <Link
              onClick={() => onClose(false)}
              style={{ height: "4.4rem" }}
              className="checkout__now--btn primary__btn text-white"
              to="/"
            >
              Continue Shopping
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default ShoppingCart;
